const enMapDrawing = {
  mapDrawing: {
    appointments: 'Appointments',
    groups: 'Groups',
    status: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    time: 'Time',
    showGroupedAppointments: 'Show grouped appointments',
    appointmentCode: 'Appointment Code',
    close: 'Close',
    cancel: 'Cancel',
    cancelOrRemoveFromGroup: 'Cancel / Remove from group',
    reschedule: 'Reschedule',
    sendConfirmationEmail: 'Send confirmation e-mail',
    sendRejectedEmail: 'Send rejected warning e-mail',
    changeAppointmentStatus: 'Change status',
    bulkActions: 'Bulk actions',
    removeGroup: 'Remove group',
    removeGroupMessage: 'Removing the group requires first removing the host',
    addToGroup: 'Add to group',
    groupInfo: 'Group info',
    changeHost: 'Change host',
    removeHost: 'Remove host',
    addHost: 'Add host',
    code: 'Code',
    scheduledBy: 'Scheduled by',
    host: 'Host',
    hostValue: 'Host value',
    date: 'Date',
    totalValue: 'Total value',
    search: 'Search',
    confirmed: 'Confirmed',
    customers: 'Customers',
    branches: 'Branches',
    hosts: 'Hosts',
    services: 'Services',
    confirmationSent: 'Confirmation sent',
    tooltipCloseToShowGroupedServices: 'Click close to list grouped appointments',
    timeInMinutes: 'Time (minutes)',
    pauseAppointmentOffer: 'Pause appointments offer',
    other: 'Other',
    pause: 'Pause',
    cancel: 'Cancel',
    unpause: 'Unpause',
    unpauseWarning: 'Are you sure you want to unpause the appointment offer?',
    removeGroupModal: {
      title: 'Remove group',
      message: 'Are you sure you want to remove the group?',
      cancel: 'Cancel',
      remove: 'Remove',
    },
    removeAppointmentFromGroupModal: {
      title: 'Remove appointment from group',
      type: 'Type',
      status: 'Status',
      code: 'Code',
      realEstate: 'Real Estate',
      cancel: 'Cancel',
      remove: 'Remove',
    },
    drawPolygon: 'Draw polygon',
    drawingHint: 'Click the start point to close · Esc to cancel',
    clearHint: 'Esc to clear selection',
    messages: {
      appointmentNotFound: 'Appointment not found',
    },
  }
}

export default enMapDrawing
